import { render, staticRenderFns } from "./Baseurl.vue?vue&type=template&id=686bd688"
import script from "./Baseurl.vue?vue&type=script&lang=js"
export * from "./Baseurl.vue?vue&type=script&lang=js"
import style0 from "./Baseurl.vue?vue&type=style&index=0&id=686bd688&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports